class OnboardingQuiz extends HTMLElement {
  constructor() {
    super();
    this.isInitialized = false;
  }

  connectedCallback() {
    if (this.isInitialized) {
      return;
    }

    this.isInitialized = true;

    this.#addEventListeners();
    this.dataset.ready = 'true';
    this.#fireEvent('step_viewed', 'step_1_spirit');

    this.#processPendingClick();
  }

  #addEventListeners() {
    this.querySelectorAll('.onboarding-quiz__option').forEach((option) => {
      option.addEventListener('click', (event) => {
        const selectedOption = event.target.closest('.onboarding-quiz__option');
        const productType = this.#getProductType(selectedOption);
        this.#fireEvent('spirit_selected', productType);

        const optionType = selectedOption.dataset.optionType;
        if (optionType === 'link') {
          const destination = selectedOption.dataset.linkUrl;
          if (destination) {
            this.#fireEvent('link_option_clicked', productType);
            window.location.assign(destination);
          }
          return;
        }

        this.#onOptionSelected(event);

        this.#moveToNextStep();
      });
    });
  }

  #onOptionSelected(event) {
    const selectedOption = event.target.closest('.onboarding-quiz__option');
    this.selectedStep = selectedOption.dataset.step;
  }

  #selectStepById(stepId) {
    if (!stepId) {
      return;
    }

    this.selectedStep = stepId;
    this.#moveToNextStep();
  }

  #processPendingClick() {
    const pendingClick = window.__onboardingQuizPendingClick;
    if (!pendingClick || !pendingClick.step) {
      return;
    }

    const sectionElement = this.closest('section');
    const sectionId = sectionElement ? sectionElement.id : null;
    if (pendingClick.quizSection && pendingClick.quizSection !== sectionId) {
      return;
    }

    const pendingOption = this.querySelector(`.onboarding-quiz__option[data-step="${pendingClick.step}"]`);
    if (!pendingOption) {
      return;
    }

    const productType = this.#getProductType(pendingOption);
    this.#fireEvent('spirit_selected', productType);
    this.#selectStepById(pendingClick.step);
    window.__onboardingQuizPendingClick = null;
  }

  #moveToNextStep() {
    const steps = this.querySelectorAll('.onboarding-quiz__step');

    steps.forEach((step) => {
      step.classList.add('hidden');
    });

    this.#showNextStep();

    window.dispatchEvent(new CustomEvent('change-checkout-step', { detail: { step: 2 } }));
  }

  moveToStart() {
    const steps = this.querySelectorAll('.onboarding-quiz__step');

    steps.forEach((step) => {
      step.classList.add('hidden');
    });

    this.selectedStep = null;

    this.querySelector(`.onboarding-quiz__step[data-step="start"]`).classList.remove('hidden');

    window.dispatchEvent(new CustomEvent('change-checkout-step', { detail: { step: 1 } }));
  }

  #showNextStep() {
    const comparisonTable = this.querySelector(`comparison-table[data-step="option_${this.selectedStep}"]`);
    comparisonTable.classList.remove('hidden');
    this.#fireEvent('step_viewed', 'step_2_box');
  }

  #getProductType(option) {
    const handle = option.dataset.handles.toLowerCase();

    if (!handle) {
      const optionTitle = option.querySelector('.onboarding-quiz__option-title')?.textContent || 'link';
      return optionTitle.trim().toLowerCase().replace(/\s+/g, '_');
    }

    switch (handle) {
      case 'gotm':
        return 'gin';
      case 'rotm':
        return 'rum';
      default:
        return handle;
    }
  }

  #fireEvent(eventAction, eventValue) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'site_interaction',
      context: 'quiz_selection',
      action: eventAction,
      value: eventValue,
    });
  }
}

if (!customElements.get('onboarding-quiz')) {
  window.customElements.define('onboarding-quiz', OnboardingQuiz);
}
